import Modal from 'components/Modal'
import Button from 'components/Button'
import { HiOutlineInformationCircle } from 'react-icons/hi'

type AcceptDialogProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  onClickAccept: () => void
  onClickDecline: () => void
}

export default function AcceptDialog({
  isOpen,
  setIsOpen,
  onClickAccept,
  onClickDecline
}: AcceptDialogProps) {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      manualClose={true}
      title="Give us permission to help you"
      icon={HiOutlineInformationCircle}
    >
      <p className="text-sm text-gray-600 break-words mt-6">
        TxnLab is requesting permission to share and record your browser session on the NFD platform
        for the purpose of debugging. The recording will be deleted after 30 days.
      </p>
      <div className="space-x-2 mt-6">
        <Button onClick={onClickDecline}>Decline</Button>
        <Button variant="gradient" onClick={onClickAccept}>
          Accept
        </Button>
      </div>
    </Modal>
  )
}
